import { useEffect, useState } from "react";

export const useScrollspy = (hashes) => {
  const [active, setActive] = useState(hashes[0]);

  useEffect(() => {
    const isMobile = window.matchMedia("(max-width: 1023px)").matches;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setActive(`#${entry.target.id}`);
        });
      },
      isMobile
        ? { rootMargin: "-12% 0px -72% 0px", threshold: 0 }
        : { rootMargin: "-35% 0px -55% 0px", threshold: 0 }
    );
    hashes.forEach((h) => {
      const el = document.querySelector(h);
      if (el) observer.observe(el);
    });
    return () => observer.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return active;
};

export const SECTION_IDS = [
  "#inicio",
  "#solucoes",
  "#impacto",
  "#negocios-locais",
  "#metodologia",
  "#portfolio",
  "#sobre",
  "#faq",
  "#contato",
];

export const SECTION_THEMES = {
  "#inicio": "#050607",
  "#solucoes": "#07090C",
  "#impacto": "#0A0D10",
  "#negocios-locais": "#06090B",
  "#metodologia": "#080B0E",
  "#portfolio": "#0B0E11",
  "#sobre": "#070908",
  "#faq": "#060809",
  "#contato": "#090C0F",
};
